import { Component, ChangeDetectionStrategy } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {FormControl} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {GIRKO_ROUTES} from '../girko.router.module';

const JWT_KEY = '[girko] JWT token';

@Component({
  selector: 'girko-login',
  template: `
    <input type="text" name="username" placeholder="Username" [formControl]="username">
    <input type="password" name="password" placeholder="Password" [formControl]="password">
    <button (click)="submit()">Login</button>
    
    <button (click)="changeLanguage('uk')" style="margin-left: 20px">ua</button>
    <button (click)="changeLanguage('ru')">ru</button>
    
    <nav>
      <a [routerLink]="[route.path]" *ngFor="let route of routes">{{route.title}}</a>
    </nav>
  `,
  styles: [`
    nav a {
      margin: 10px;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
  username = new FormControl();
  password = new FormControl();

  routes = GIRKO_ROUTES.map(route => ({
    path: route.path,
    title: (route.loadChildren as string).split('#')[1].split('Module')[0],
  }));

  constructor(private http: HttpClient, public translate: TranslateService) {}

  submit() {
    return this.http.post<LoginResponse>(`${environment.urlPrefix}/api/login/`, {
      username: this.username.value,
      password: this.password.value,
    }).subscribe(
      (res) => {
        const jwtToken = res.token;
        localStorage.setItem(JWT_KEY, jwtToken);
        window.location.reload();
      },
      err => {
        console.error(err);
        alert(err);
      },
    );
  }

  changeLanguage(lang: string) {
    this.translate.use(lang);
  }
}

interface LoginResponse {
  token: string;
}
